import React from 'react'
import UninstallPage from '../uninstall'

const UninstallPageFr = () => {
    return <UninstallPage languageCode="en" />
}

export default UninstallPageFr
